module.exports = __webpack_public_path__ + "img/2-2.45c75afc.png";